import PropTypes from 'prop-types';
import {
	StyledTitleRowItem,
	StyledTitleRowItemTypography,
} from '@styles/heading-structure.styles';
import { injectTemplateVars } from '@utils/inject-template-vars';

const HeadingStructureTitleRowItem = ({ icon, text }) => {
	return (
		<StyledTitleRowItem>
			{icon}

			<StyledTitleRowItemTypography variant="body2" as="span">
				{injectTemplateVars(text, { b: ({ children }) => <b>{children}</b> })}
			</StyledTitleRowItemTypography>
		</StyledTitleRowItem>
	);
};

HeadingStructureTitleRowItem.propTypes = {
	icon: PropTypes.node.isRequired,
	text: PropTypes.string.isRequired,
};

export default HeadingStructureTitleRowItem;
